module.exports = __webpack_public_path__ + "img/test.dd191cd7.jpg";